var map = {
	"./": 216,
	"./DEVICE_COMPATIBILITY_CHECKER": 427,
	"./DEVICE_COMPATIBILITY_CHECKER.js": 427,
	"./index": 216,
	"./index.js": 216,
	"./tests/DEVICE_COMPATIBILITY_CHECKER.test": 650,
	"./tests/DEVICE_COMPATIBILITY_CHECKER.test.js": 650,
	"./tests/__snapshots__/DEVICE_COMPATIBILITY_CHECKER.test.js.snap": 1526,
	"./tests/index.test": 706,
	"./tests/index.test.js": 706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1183;